import firebase from "firebase/app";
import "firebase/firestore";

import firestore from "src/apiService/firestore";
import type {
  DepopInventoryImportResume,
  DepopSalesImportResume,
} from "src/interfaces/plaidIntegration.interface";

export async function saveDepopSalesResume(
  integrationId: string,
  resume: DepopSalesImportResume
) {
  await firestore().collection("Plaid_Integrations").doc(integrationId).update({
    depopSalesImportResume: resume,
  });
}

export async function clearDepopSalesResume(integrationId: string) {
  await firestore().collection("Plaid_Integrations").doc(integrationId).update({
    depopSalesImportResume: firebase.firestore.FieldValue.delete(),
  });
}

export async function saveDepopInventoryResume(
  integrationId: string,
  resume: DepopInventoryImportResume
) {
  await firestore().collection("Plaid_Integrations").doc(integrationId).update({
    depopInventoryImportResume: resume,
  });
}

export async function clearDepopInventoryResume(integrationId: string) {
  await firestore().collection("Plaid_Integrations").doc(integrationId).update({
    depopInventoryImportResume: firebase.firestore.FieldValue.delete(),
  });
}
